import service from '@/middleware';

class ForwardApi {

    async getAll() {
        const result = await service.http.get("/api/forward/getAll");
        return result.data;
    }

    async create(data) {
        const result = await service.http.post("/api/forward/create", data);
        return result.data;
    }

    async update(data) {
        const result = await service.http.put("/api/forward/update", data);
        return result.data;
    }

    async detele(unitId) {
        const result = await service.http.delete(`/api/forward/delete/${unitId}`);
        return result.data;
    }
}

export default new ForwardApi();